























import Modal from "../core/Modals/Modal.vue";
import RemplacementsInput from "./RecurrenceInterventionModalPartials/RemplacementEditPartials/RemplacementsInput.vue";

export default {
    name: "RemplacementAlertsModal",
    components: { RemplacementsInput, Modal },
    props: {
        showModal: Boolean,
        remplacements: Array,
    },
    data() {
        return {
            recurrenceIntervention: {},
        };
    },
    created() {
        this.recurrenceIntervention =
            this.remplacements[0].recurrence_interventions[0];
    },
    methods: {
        closeModal(): void {
            this.editing = false;
            this.$emit("close-modal");
        },
    },
};
